import React from 'react'
import ReactDOM from 'react-dom/client'
import Card from 'react-bootstrap/Card'
import '../../index.css'
import { useEffect, useState } from 'react'
import axios from 'axios'
import dayjs from 'dayjs'

import {
    Column,
    Table as ReactTable,
    PaginationState,
    useReactTable,
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    ColumnDef,
    OnChangeFn,
    flexRender,
} from '@tanstack/react-table'
import DataTable from 'react-data-table-component'
import { useNavigate } from 'react-router-dom';
import { initialQueryState, KTIcon, useDebounce } from '../../../../_metronic/helpers'
// import {UsersListPagination} from './components/pagination/UsersListPagination'
import { number } from 'yup'

export function Management() {

    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const editItem = (data: any) => {
        console.log(data.original)
        navigate('/EditParticipant', { state: data.original });
    };
    const [tableData, setTableData] = useState<any>([])
    //const rerender = React.useReducer(() => ({}), {})[1]
    const API_URL = process.env.REACT_APP_API_URL
    const columns = React.useMemo<ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'image',
                header: () => <span>Profile</span>,
                footer: (props) => props.column.id,
                cell: (props) => <img src={props.row.original.image} className='circleIMG' width={60} />,
            },
            {
                accessorKey: 'firstname',
                header: 'Firstname',
                cell: (props) => <span className='down50'>{props.row.original.firstname}</span>,
                footer: (props) => props.column.id,
            },
            {
                accessorKey: 'lastname',
                header: 'Lastname',
                footer: (props) => props.column.id,
            },
            /*{
              accessorKey: 'email',
              header: 'Email',
              footer: (props) => props.column.id,
            },*/
            {
                accessorKey: 'code',
                header: 'ทะเบียนรถ',
                footer: (props) => props.column.id,
            },

            {
                accessorKey: 'mobile_number',
                header: 'Type',
                footer: (props) => props.column.id,
                cell: (props) => (
                    <p>
                        {''}
                    </p>
                ),
            },

            {
                accessorKey: 'mobile_number',
                header: 'mobile_number',
                footer: (props) => props.column.id,
            },


            {
                accessorKey: 'mobile_number',
                header: 'create date',
                footer: (props) => props.column.id,
                cell: (props) => (
                    <p>
                        {dayjs(props.row.original.created_date).format('DD-MM-YYYY')}
                    </p>
                ),
            },
            {
                accessorKey: 'point',
                header: 'Remain Point',
                footer: (props) => props.column.id,
            },

        ],
        []
    )

    const [data, setData] = React.useState([])
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [totalPage, setTotalPage] = useState(1)
    const [totalRow, setTotalRow] = useState(10)
    const getAPI = async () => {
        const data = await axios.get(`${API_URL}/bo/participant?page=1&limit=10`).then((res) => {
            setTableData(res.data.data)
            setData(() => res.data.data)
            setPage(res.data.page)
            setLimit(res.data.limit)
            setTotalRow(res.data.total)
            setTotalPage(Math.ceil(res.data.total / res.data.limit))
        })
        //return data.data.data
    }

    const handlePageChange = (newPage: number) => {
        if (newPage <= totalPage && newPage > 0) {
            setPage(newPage);
            refreshAPI(newPage, limit);
        }
    };

    const refreshAPI = async (page: Number, limit: Number) => {
        const data = await axios
            .get(`${API_URL}/bo/participant?page=${page}&limit=${limit}`)
            .then((res) => {
                setTableData(res.data.data)
                setData(() => res.data.data)
                setTotalRow(res.data.total)
                setTotalPage(Math.ceil(res.data.total / res.data.limit))
            })
    }

    const [searchTerm, setSearchTerm] = useState<string>('')
    const refreshAPISearch = async (search: string) => {
        setSearchTerm(search)
        const data = await axios
            .get(`${API_URL}/bo/participant?page=${1}&limit=${limit}&search=${search}`)
            .then((res) => {
                setTableData(res.data.data)
                setData(() => res.data.data)
                setPage(1)
                setTotalRow(res.data.total)
                setTotalPage(Math.ceil(res.data.total / res.data.limit))
            })
    }
    const table = useReactTable({
        data,
        columns,
        // Pipeline
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        //
        debugTable: true,
    })
    useEffect(
        () => {
            getAPI()
        },
        [] // Only re-call effect if value or delay changes
    )

    return (

        <Card className='table-responsive fontWrap'>
            <Card.Header>
                <div className='card-title m-0 py-5 col-12'>
                    <h3 className='fw-bolder m-0'>User Management</h3>
                </div>
                
                <div className='d-flex align-items-center position-relative my-3 pb-3'>
                        <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
                        <input
                            type='text'
                            data-kt-user-table-filter='search'
                            className='form-control form-control-solid w-250px ps-14'
                            placeholder='Search user'
                            value={searchTerm}
                            onChange={(e) => refreshAPISearch(e.target.value)}
                        />
                    </div>
                {/** add button จุดเพิ่มปุ่ม */}
                {/*<div className='d-flex justify-content-end card-title' data-kt-user-table-toolbar='base'>
          {/*<button type='button' className='btn btn-light-primary me-3'>
            <KTIcon iconName='exit-up' className='fs-2' />
            Export
          </button>}

          <button type='button' className='btn btn-primary' onClick={() => {}}>
            <KTIcon iconName='plus' className='fs-2' />
            Add User
          </button>
        </div>*/}
            </Card.Header>

            <table className='table table-striped gy-7 gs-7'>
                <thead>
                    {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map((header) => {
                                return (
                                    <th key={header.id} colSpan={header.colSpan}>
                                        {header.isPlaceholder ? null : (
                                            <div className='fw-bold fs-7 text-gray-1200 border-bottom-2 border-gray-200'>
                                                {flexRender(header.column.columnDef.header, header.getContext())}
                                            </div>
                                        )}
                                    </th>
                                )
                            })}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {table.getRowModel().rows.map((row) => {
                        return (
                            <tr key={row.id}>
                                {row.getVisibleCells().map((cell) => {
                                    return (
                                        <td key={cell.id}>
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </td>
                                    )
                                })}
                                {/**add button เพิ่มปุ่ม */}
                                {/*<td>
                  <button type='button' className='btn btn-primary listButton' onClick={() => {editItem(row)}}>
                    Edit
                  </button>
                  <span> </span>
                  {/*<button type='button' className='btn btn-primary' onClick={() => {}}>
                    Add Point
                  </button>}
              </td>*/}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            <div className='h-2' />
            <Card.Footer>
                <div className='row'>
                    <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>
                        <span>
                            <select
                                className='form-select form-select-sm form-select-solid'
                                value={limit}
                                onChange={(e) => {
                                    setLimit(Number(e.target.value))
                                    refreshAPI(page, Number(e.target.value))
                                    table.setPageSize(Number(e.target.value))
                                }}
                            >
                                {[10, 20, 30, 40, 50].map((pageSize) => (
                                    <option key={pageSize} value={pageSize}>
                                        {pageSize}
                                    </option>
                                ))}
                            </select>
                        </span>
                    </div>
                    <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>

                        <div>
                            <ul className="pagination">
                                <li className="page-item previous disabled">
                                    <a href="#" className="page-link">
                                        <i className="previous"></i>
                                    </a>
                                </li>
                                {[...Array(totalPage)].map((_, index) => (
                                    <li key={index} className={`page-item ${page === index + 1 ? 'active' : ''}`}>
                                        <a href="#" className="page-link" onClick={() => handlePageChange(index + 1)}>
                                            {index + 1}
                                        </a>
                                    </li>
                                ))}
                                <li className="page-item next">
                                    <a href="#" className="page-link">
                                        <i className="next"></i>
                                    </a>
                                </li>
                            </ul>

                        </div>
                    </div>


                </div>

                {/* <UsersListPagination API_NAME={'/bo/participant?page=1&limit=10'} /> */}

                <span className='flex items-center gap-1 d-none'>
                    <strong>
                        Page {page} of {totalPage}
                    </strong>
                </span>
                <span className='flex items-center gap-1 mr-3 p-4 d-none'>
                    | Go to page:
                    <input
                        type='number'
                        defaultValue={page}
                        value={page}
                        onChange={(e) => {
                            if (Number(e.target.value) <= totalPage && Number(e.target.value) > 0) {
                                /*const page = e.target.value ? Number(e.target.value) - 1 : 0
                                table.setPageIndex(page)*/
                                setPage(Number(e.target.value))
                                refreshAPI(Number(e.target.value), limit)
                            }
                        }}
                        className='border p-1 rounded w-16'
                    />
                </span>
                <span className='d-none'>
                    <select
                        className='ml-2'
                        value={limit}
                        onChange={(e) => {
                            setLimit(Number(e.target.value))
                            refreshAPI(page, Number(e.target.value))
                            table.setPageSize(Number(e.target.value))
                        }}
                    >
                        {[10, 20, 30, 40, 50].map((pageSize) => (
                            <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                            </option>
                        ))}
                    </select>
                </span>
            </Card.Footer>

        </Card>
        // <>
        //     <div className='card mb-5 mb-xl-10'>
        //         <div
        //             className='card-header border-0 cursor-pointer'
        //             role='button'
        //             data-bs-toggle='collapse'
        //             data-bs-target='#kt_account_profile_details'
        //             aria-expanded='true'
        //             aria-controls='kt_account_profile_details'
        //         >
        //             <div className='card-title m-0'>
        //                 <h3 className='fw-bolder m-0'>User Manangement</h3>
        //             </div>
        //         </div>
        //         <table className="table table-rounded table-striped border gy-7 gs-7">
        //             <thead>
        //                 <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
        //                     <th>Name</th>
        //                     <th>Position</th>
        //                     <th>Office</th>
        //                     <th>Age</th>
        //                     <th>Start date</th>
        //                     <th>Salary</th>
        //                 </tr>
        //             </thead>
        //             <tbody>
        //                 <tr>
        //                     <td>Tiger Nixon</td>
        //                     <td>System Architect</td>
        //                     <td>Edinburgh</td>
        //                     <td>61</td>
        //                     <td>2011/04/25</td>
        //                     <td>$320,800</td>
        //                 </tr>
        //                 <tr>
        //                     <td>Garrett Winters</td>
        //                     <td>Accountant</td>
        //                     <td>Tokyo</td>
        //                     <td>63</td>
        //                     <td>2011/07/25</td>
        //                     <td>$170,750</td>
        //                 </tr>
        //             </tbody>
        //         </table>
        //     </div>

        //     <div className='card mb-5 mb-xl-10 d-none'>
        //         <div
        //             className='card-header border-0 cursor-pointer'
        //             role='button'
        //             data-bs-toggle='collapse'
        //             data-bs-target='#kt_account_profile_details'
        //             aria-expanded='true'
        //             aria-controls='kt_account_profile_details'
        //         >
        //             <div className='card-title m-0'>
        //                 <h3 className='fw-bolder m-0'>Create Campaign</h3>
        //             </div>
        //         </div>

        //         <div id='kt_account_profile_details' className='collapse show'>
        //             <div className='card-body border-top p-9'>

        //                 <div className='row mb-6'>
        //                     <label className='col-lg-4 col-form-label required fw-bold fs-6'>ประเภทแคมเปญ</label>

        //                     <div className='col-lg-8 fv-row'>
        //                         <select className="form-select form-select-solid form-select-lg">
        //                             {/* <option value=''>Select a type campaign..</option> */}
        //                             <option value='Earn'>Earn</option>
        //                         </select>
        //                     </div>
        //                 </div>

        //                 <div className='row mb-6'>
        //                     <label className='col-lg-4 col-form-label required fw-bold fs-6'>รายการแคมเปญ</label>

        //                     <div className='col-lg-8 fv-row'>
        //                         <select className="form-select form-select-solid form-select-lg">
        //                             {/* <option value=''>Select a campaign..</option> */}
        //                             <option value='Earn'>Birthday</option>
        //                         </select>
        //                     </div>
        //                 </div>

        //                 <div className='row mb-6'>
        //                     <label className='col-lg-4 col-form-label required fw-bold fs-6'>ประเภทอีเวนท์</label>

        //                     <div className='col-lg-8 fv-row'>
        //                         <select className="form-select form-select-solid form-select-lg">
        //                             {/* <option value=''>Select a type event..</option> */}
        //                             <option value='Earn'>All</option>
        //                         </select>
        //                     </div>
        //                 </div>

        //                 <div className='row mb-6'>
        //                     <label className='col-lg-4 col-form-label required fw-bold fs-6'>กลุ่มเป้าหมาย</label>

        //                     <div className='col-lg-8 fv-row'>
        //                         <select className="form-select form-select-solid form-select-lg">
        //                             {/* <option value=''>Select a target group..</option> */}
        //                             <option value='Earn'>All</option>
        //                         </select>
        //                     </div>
        //                 </div>

        //                 <div className='row mb-6'>
        //                     <label className='col-lg-4 col-form-label fw-bold fs-6'>
        //                         <span className='required'>ชื่อแคมเปญ</span>
        //                     </label>

        //                     <div className='col-lg-8 fv-row'>
        //                         <input
        //                             type='text'
        //                             className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
        //                             placeholder='Campaign name'
        //                         />
        //                     </div>
        //                 </div>

        //                 <div className='row mb-6'>
        //                     <label className='col-lg-4 col-form-label fw-bold fs-6'>
        //                         <span className='required'>รายละเอียดแคมเปญ</span>
        //                     </label>

        //                     <div className='col-lg-8 fv-row'>
        //                         <input
        //                             type='text'
        //                             className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
        //                             placeholder='Campaign detail'
        //                         />
        //                     </div>
        //                 </div>

        //                 <div className='row mb-6'>
        //                     <label className='col-lg-4 col-form-label fw-bold fs-6'>
        //                         <span className='required'>รูปแบบการปรับเพิ่ม</span>
        //                     </label>

        //                     <div className='col-lg-8 fv-row'>
        //                         <select className="form-select form-select-solid form-select-lg">
        //                             {/* <option value=''>Select a target group..</option> */}
        //                             <option value='Earn'>จำนวนคะแนนที่ปรับเพิ่ม</option>
        //                         </select>
        //                     </div>
        //                 </div>

        //                 <div className='row mb-6'>
        //                     <label className='col-lg-4 col-form-label fw-bold fs-6'>
        //                         <span className='required'>จำนวนคะแนนที่ปรับเพิ่ม</span>
        //                     </label>

        //                     <div className='col-lg-8 fv-row'>
        //                         <input
        //                             type='text'
        //                             className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
        //                             placeholder='Amount point increase'
        //                             value={0}
        //                         />
        //                     </div>
        //                 </div>

        //                 <div className="input-group" id="kt_td_picker_simple" data-td-target-input="nearest" data-td-target-toggle="nearest">
        //                     <input id="kt_td_picker_basic_input" type="text" className="form-control" data-td-target="#kt_td_picker_basic" />
        //                     <span className="input-group-text" data-td-target="#kt_td_picker_basic" data-td-toggle="datetimepicker">
        //                         <i className="ki-duotone ki-calendar fs-2"><span className="path1"></span><span className="path2"></span></i>
        //                     </span>
        //                 </div>

        //                 {/* <div className='row mb-6'>
        //                     <label className='col-lg-4 col-form-label fw-bold fs-6'>Communication</label>

        //                     <div className='col-lg-8 fv-row'>
        //                         <div className='d-flex align-items-center mt-3'>
        //                             <label className='form-check form-check-inline form-check-solid me-5'>
        //                                 <input
        //                                     className='form-check-input'
        //                                     name='communication[]'
        //                                     type='checkbox'
        //                                     defaultChecked={true}
        //                                     onChange={() => {
        //                                     }}
        //                                 />
        //                                 <span className='fw-bold ps-2 fs-6'>Email</span>
        //                             </label>

        //                             <label className='form-check form-check-inline form-check-solid'>
        //                                 <input
        //                                     className='form-check-input'
        //                                     name='communication[]'
        //                                     type='checkbox'
        //                                     defaultChecked={true}
        //                                     onChange={() => {
        //                                     }}
        //                                 />
        //                                 <span className='fw-bold ps-2 fs-6'>Phone</span>
        //                             </label>
        //                         </div>
        //                     </div>
        //                 </div>

        //                 <div className='row mb-0'>
        //                     <label className='col-lg-4 col-form-label fw-bold fs-6'>Allow Marketing</label>

        //                     <div className='col-lg-8 d-flex align-items-center'>
        //                         <div className='form-check form-check-solid form-switch fv-row'>
        //                             <input
        //                                 className='form-check-input w-45px h-30px'
        //                                 type='checkbox'
        //                                 id='allowmarketing'
        //                                 defaultChecked={false}
        //                                 onChange={() => {
        //                                 }}
        //                             />
        //                             <label className='form-check-label'></label>
        //                         </div>
        //                     </div>
        //                 </div> */}
        //             </div>

        //             <div className='card-footer d-flex justify-content-center py-6 px-9'>
        //                 <button className="btn btn-light btn-active-light-primary me-2">Cancel</button>
        //                 <button type='submit' className='btn btn-primary' disabled={loading}>
        //                     {!loading && 'Save'}
        //                     {loading && (
        //                         <span className='indicator-progress' style={{ display: 'block' }}>
        //                             Please wait...{' '}
        //                             <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
        //                         </span>
        //                     )}
        //                 </button>
        //             </div>
        //         </div>
        //     </div>
        // </>
    )
}